<template>
    <svg width="13" height="27" viewBox="0 0 13 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 26L2 13.5L12 1" stroke="#00458D" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGHelpArrowLeft',
};
</script>

<style scoped lang="scss">

</style>
